var _line, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 537,
    viewBox: "0 0 408 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 374.42,
    y1: 480.675,
    x2: 88.4196,
    y2: 357.675,
    stroke: "#202531",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.9854,
    y1: 15.6581,
    x2: 93.9854,
    y2: 353.658,
    stroke: "#202531",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 477,
    r: 60,
    fill: "#E50C33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 60,
    r: 60,
    fill: "#0196BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 354,
    r: 90,
    fill: "#FDA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGroup2);
export default __webpack_public_path__ + "static/media/dotGroup2.3e5a2a2352295ef3056114197fa02666.svg";
export { ForwardRef as ReactComponent };